export class ZoneError {
  error: string;
  component: string;
}
